import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {
  ArchiveCaseCommand,
  CreateArrangementFromExistingCaseCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand,
  SyncParticipantsCommand,
  SyncProjectEntityToCompanyCommand
} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {takeUntil} from 'rxjs/operators';
import {BasketProvider} from '@shared/models/basket-provider';
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";

@Injectable({
  providedIn: 'root',
})
export class CreateSurveyExecutionLinkCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(protected commandService: CommandService) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    // This is to avoid cyclic breadcrumb insertion in data survey eat through WorkflowExternalCommandConsumer
    if (command.name === 'WorkflowExternalCommand' && command.fieldValues['Breadcrumbs']) {
      const breadcrumbs: BreadcrumbModel[] = command.fieldValues['Breadcrumbs'];
      while (breadcrumbs.length && breadcrumbs[breadcrumbs.length - 1].relativePath === '') {
        breadcrumbs.pop();
      }
    }
    handler.executeCommand(command);
    return true;
  }
}
